import { api } from "./apiSlice";

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export interface DonorHomeStats {
  totalDonations: number;
  totalPoints: number;
  donationStreak?: number;
  badge: string | null;
  eligibleToDonate: boolean;
  nextEligibleDate: string | null;
  lastDonationDate: string | null;
  nextAppointmentDate?: string | null;
  nextAppointmentId?: string | null;
}

export interface DashboardAppointment {
  id: string;
  appointmentDateTime: string;
  scheduled: string;
  medicalEstablishment: { id: string; name: string; address: string; district: string };
  slot?: { id: string; startTime: string; endTime: string };
  location: string;
}

export interface DashboardActivity {
  id: string;
  type: string;
  title: string;
  description: string;
  createdAt: string;
  isRead: boolean;
}

export interface DashboardEmergency {
  id: string;
  title: string;
  description: string;
  bloodTypesNeeded: unknown;
  urgencyLevel: string;
  status: string;
  expiresAt: string;
  contactNumber: string;
  hospital: { id: string; name: string; address: string; district: string };
}

export interface DashboardNotification {
  id: string;
  type: string;
  title: string;
  message: string;
  isRead: boolean;
  createdAt: string;
}

export interface HomeDashboard {
  userStats: DonorHomeStats;
  todaysAppointment: DashboardAppointment | null;
  upcomingAppointments: DashboardAppointment[];
  recentActivities: DashboardActivity[];
  emergencies: DashboardEmergency[];
  notifications: DashboardNotification[];
}

export const homeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getHomeDashboard: builder.query<HomeDashboard, void>({
      query: () => "/home/dashboard",
      transformResponse: (res: ApiResponse<HomeDashboard>) => res.data,
      providesTags: ["Home"],
    }),
  }),
});

export const { useGetHomeDashboardQuery } = homeApi;
